"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const Picasso_1 = require("../Picasso");
Picasso_1.PicassoProvider.override(({ palette }) => ({
    MuiChip: {
        root: {
            fontSize: '16px',
            backgroundColor: palette.blue.light,
            color: palette.primary.main,
            height: '1.5em'
        },
        label: {
            fontSize: '.75em',
            fontWeight: 600
        },
        deletable: {
            '&:focus': {
                backgroundColor: palette.blue.light
            }
        }
    }
}));
exports.default = () => styles_1.createStyles({
    root: {}
});
//# sourceMappingURL=styles.js.map